import React from "react";
import { ContentSection } from "sprint-common-web";

import { AspectRatiosDataProvider } from "../../../../../../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import { AspectTypesDataProvider } from "../../../../../../../common/data/lookup-data-providers/AspectTypesDataProvider";
import { StandardsDataProvider } from "../../../../../../../common/data/lookup-data-providers/StandardsDataProvider";
import { FileRecordDetails } from "../../../../../../common/file-record-details/FileRecordDetails";
import { VideoFileRecordTechnicalView } from "../../../../../../common/file-record-details/technical/VideoFileRecordTechnicalView";

interface VideoFileRecordTechnicalSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const VideoFileRecordTechnicalSection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: VideoFileRecordTechnicalSectionProps): JSX.Element => {
    return (
        <AspectTypesDataProvider>
            <AspectRatiosDataProvider>
                <StandardsDataProvider>
                    <ContentSection
                        header="File record technical"
                        isLoading={isFileRecordDetailsLoading}
                        style={{ height: 300 }}
                    >
                        <VideoFileRecordTechnicalView fileRecordDetails={fileRecordDetails} />
                    </ContentSection>
                </StandardsDataProvider>
            </AspectRatiosDataProvider>
        </AspectTypesDataProvider>
    );
};
